import React, { useEffect, useState } from 'react';
import axios from "axios";
const MetabaseEmbed = () => {

  const [metabaseURL, setMetabaseURL] = useState([])
  useEffect(() => {
    if (localStorage.getItem('access')) {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('access')}`,
          Accept: 'application/json'
        }
      };
      let resp = []
      // GET request using axios inside useEffect React hook
      axios.get('/api/reports/embeded-report-list/', config)
        .then((res) => resp = res.data.results)
        .then(() => {
          // console.log("this is iframeUrl ######", resp)
          resp.foreach((report) => {
            let iframeUrl = report.report_url.embeded_report_list;
            console.log("this is iframeUrl ######", iframeUrl)
            setMetabaseURL(iframeUrl)
            return null;
          })

        })

    }
  }, []);

  return (
    <React.StrictMode>
      <div>
        <iframe
          src={metabaseURL}
          frameBorder={0}
          width={"100%"}
          height={1600}
          allowtransparency="true"
        />
      </div>
    </React.StrictMode>
  );
};

export default MetabaseEmbed;
